import { ShareImageDialog } from "@/components/BadgeShare";
import { renderVaultImage } from "@/lib/vaultImage";
import { imgSrc } from "@/lib/api";

export function VaultShare({ win, user, onClose }) {
  const u = { ...user, picture: user.picture ? imgSrc(user.picture) : null };
  const link = `${window.location.origin}/registrieren?ref=${user.referral_code}`;
  return (
    <ShareImageDialog prefix="vault" title="Tresor-Gewinn teilen" alt={`Tresor geknackt: +${win.pot} Punkte`} fileBase={`itzcouple-tresor-${win.round_no}`} onClose={onClose}
      description="Zeig allen, dass du den Goldenen Tresor geknackt hast – dein Einladungscode ist mit drauf."
      msg={`Ich habe den Goldenen Tresor in der itzPlay Community geknackt: +${win.pot} Punkte! 🔓💰 Knack den nächsten: ${link}`}
      render={(format) => renderVaultImage({ pot: win.pot, code: win.code, no: win.round_no, user: u, format })} deps={[win.pot, win.code, user.user_id]} />
  );
}
